import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { MenuItem, Select } from '@mui/material';
import { PaloThemeProvider, tokens } from '@synergy/theme-palo';
import { ReactElement } from 'react';
import { useFilter } from '@synergy/components';

const OPEN = 'open';
const ALL = 'all';

/**
 * The cockpit lists what is still to be done; finished documents only on
 * request (GF 26.10.2026, #2326 R-235). The server reads `filter[scope]=all`
 * and holds which status counts as open for each document type.
 */
export const PaloScopeQuickFilter = (): ReactElement => {
    const { filter, updateFilter } = useFilter();
    const value = ALL === filter.get(FilterParams.Scope) ? ALL : OPEN;

    const onChange = (next: string): void => {
        filter.delete(FilterParams.Scope);
        if (ALL === next) {
            filter.set(FilterParams.Scope, ALL);
        }
        updateFilter(filter);
    };

    return (
        <PaloThemeProvider>
            <Select
                variant="standard"
                disableUnderline
                value={value}
                onChange={event => onChange(String(event.target.value))}
                sx={{ fontSize: '12.5px', color: tokens.color.ink2, '& .MuiSelect-select': { py: 0.5 } }}
            >
                <MenuItem value={OPEN}>
                    <FormattedMessage id="app.filter.showOpenOnly" />
                </MenuItem>
                <MenuItem value={ALL}>
                    <FormattedMessage id="app.filter.showClosedToo" />
                </MenuItem>
            </Select>
        </PaloThemeProvider>
    );
};
